import { MembershipWithOrganizationTypeEnum, RoleEnum } from '@/api/rest/resources/types/membership';
import { useIsStaffUser } from '@/hooks/useIsStaffUser';
import { useUserMe } from '@/hooks/useUserMe';

export const useCanManageInsituData = () => {
  const user = useUserMe();
  const isStaff = useIsStaffUser();

  if (!user?.data) {
    return false;
  }

  if (isStaff) {
    return true;
  }

  const { membership } = user.data;

  if (membership.role !== RoleEnum.admin) {
    return false;
  }

  return membership.type === MembershipWithOrganizationTypeEnum.land_steward;
};
